import * as React from 'react';
import * as PropTypes from 'prop-types';
import { ElementWrapper, Icon, TitleText } from './elements';
import Cnt10 from '../Cnt10';

type Lab119Props = {
  className?: string;
  icon?: string;
  color?: string;
  textColor?: string;
  children?: string | number;
  animation?: boolean;
  decimals?: string | number;
  locale: string;
};

function Lab119(props: Lab119Props): React.ReactElement {
  return (
    <ElementWrapper className={props.className}>
      <Icon icon={props.icon} color={props.color} />
      <TitleText color={props.textColor}>
        {typeof props.children === 'number' ? (
          <Cnt10
            decimals={props.decimals}
            animate={props.animation}
            locale={props.locale}
          >
            {props.children}
          </Cnt10>
        ) : (
          props.children
        )}
      </TitleText>
    </ElementWrapper>
  );
}

Lab119.propTypes = {
  animation: PropTypes.bool,
  className: PropTypes.string,
  decimals: PropTypes.number,
  icon: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
  textColor: PropTypes.string,
  locale: PropTypes.string.isRequired,
};

export default Lab119;
